import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, watchEffect } from "vue";
import API from "@/api";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import {
  addAppUsingPost,
  editAppUsingPost,
  getAppVoByIdUsingGet,
} from "@/api/appController";
import { APP_SCORING_STRATEGY_MAP, APP_TYPE_MAP } from "@/constant/app";
import { aiGenerateQuestionUsingPost } from "@/api/questionController";

interface Props {
  appId: string;
  onSuccess?: (result: API.AIGenerateQuestionRequest[]) => void;
  onSSESuccess?: (result: API.AIGenerateQuestionRequest) => void;
  onSSEStart?: (event: any) => void;
  onSSEEnd?: (event: any) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AIGenerateQuestionDrawer',
  props: {
    appId: { default: () => {
    return "";
  } },
    onSuccess: {},
    onSSESuccess: {},
    onSSEStart: {},
    onSSEEnd: {}
  },
  setup(__props: any) {

const props = __props;

const form = reactive({
  optionCount: 2,
  questionCount: 4,
} as API.AIGenerateQuestionRequest);

const visible = ref(false);
const submitting = ref(false);
const SSEsubmitting = ref(false);

const handleClick = () => {
  visible.value = true;
};
const handleOk = () => {
  visible.value = false;
};
const handleCancel = () => {
  visible.value = false;
};

/**
 * 提交
 */
const handleSubmit = async () => {
  if (!props.appId) {
    return;
  }
  submitting.value = true;
  const res = await aiGenerateQuestionUsingPost({
    appId: props.appId as any,
    ...form,
  });
  if (res.data.code === 0 && res.data.data.length > 0) {
    message.success("生成成功");
    if (props.onSuccess) {
      props.onSuccess(res.data.data);
    } else {
      message.success("请在左侧菜单中选择应用查看生成的题目");
    }
    // 成功则关闭抽屉
    handleCancel();
  } else {
    message.error("生成失败");
  }
  submitting.value = false;
  //
};
/**
 * SSE提交 (流式生成)
 */
const handleSSEsubmit = async () => {
  if (!props.appId) {
    return;
  }
  SSEsubmitting.value = true;
  // 创建SSE请求
  const eventSource = new EventSource(
    // TODO 手动填写完整的后端地址
    `http://localhost:8101/api/question/ai_generate/sse?appId=${props.appId}&optionCount=${form.optionCount}&questionCount=${form.questionCount}`
  );
  let firstMessage = true;
  // 接收消息
  eventSource.onmessage = function (event) {
    if (firstMessage) {
      props.onSSEStart?.(event);
      handleCancel();
      firstMessage = false;
    }
    props.onSSESuccess?.(JSON.parse(event.data));
  };
  // 连接打开时触发
  eventSource.onopen = function (event) {
    console.log("Connection opened");
    props.onSSEStart?.(event);
    handleCancel();
  };
  // 连接关闭或出现错误时触发
  eventSource.onerror = function (event) {
    if (event.eventPhase === EventSource.CLOSED) {
      console.log("Connection closed");
      eventSource.close();
      props.onSSEEnd?.(event);
    }

    SSEsubmitting.value = false;
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_button, {
      type: "outline",
      onClick: handleClick
    }, {
      default: _withCtx(() => [
        _createTextVNode("AI 生成题目")
      ]),
      _: 1
    }),
    _createVNode(_component_a_drawer, {
      width: 340,
      visible: visible.value,
      onOk: handleOk,
      onCancel: handleCancel,
      unmountOnClose: ""
    }, {
      title: _withCtx(() => [
        _createTextVNode(" AI生成题目 ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_a_form, {
            model: form,
            style: {},
            "label-align": "left",
            "auto-label-width": "",
            onSubmit: handleSubmit
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "应用id" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(props.appId), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                field: "questionCount",
                label: "题目数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    number: "",
                    min: "1",
                    max: "20",
                    modelValue: form.questionCount,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.questionCount) = $event)),
                    placeholder: "请输入题目数量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                field: "optionCount",
                label: "选项数量"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    number: "",
                    min: "2",
                    max: "6",
                    modelValue: form.optionCount,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.optionCount) = $event)),
                    placeholder: "请输入选项数量"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        loading: submitting.value,
                        type: "primary",
                        "html-type": "submit",
                        style: {"width":"120px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(submitting.value ? "生成中..." : "一键生成"), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"]),
                      _createVNode(_component_a_button, {
                        loading: SSEsubmitting.value,
                        style: {"width":"120px"},
                        onClick: handleSSEsubmit
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(SSEsubmitting.value ? "生成中..." : "实时生成"), 1)
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})